import { takeLatest, call, put, all, takeEvery } from "redux-saga/effects";

import { getHomePage } from "@services/api";
import {
  GET_HOMEPAGE_REQ,
  HANDLE_APPLINK,
  SET_HOME_MOUNTED,
} from "../reducers/actionTypes";

import { actions } from "../reducers/homeReducer";

function* getHomePageWorker() {
  try {
    const { data } = yield call(() => getHomePage({ limit: 10 }));
    yield put(actions.getHomePageSuccess(data));
  } catch (e) {
    console.log(e);
    yield put(actions.getHomePageFail());
  }
}

export default function* () {
  yield all([
    takeLatest(GET_HOMEPAGE_REQ, getHomePageWorker),
    // TODO verify if this action is being dispatched
  ]);
}
